import React from "react";
import {
  CheckCircle2,
  Circle,
  CircleSlash,
  Loader2,
  XCircle,
} from "lucide-react";
import { StepStatus } from "../../../../types/orchestration";

/**
 * Shape-coded status icon so step state is distinguishable WITHOUT relying on
 * the red/green hue (WCAG 1.4.1 "Use of Color"). Color is kept as redundant
 * reinforcement. succeeded = check, failed = x, running = spinner,
 * pending = outline circle, skipped = slashed circle.
 */
const ICON_COLOR: Record<StepStatus, string> = {
  succeeded: "text-green-600 dark:text-green-500",
  running: "text-rp-amber",
  failed: "text-red-600 dark:text-red-500",
  pending: "text-gray-400 dark:text-gray-500",
  skipped: "text-gray-400 dark:text-gray-500",
};

interface StepStatusIconProps {
  status: StepStatus;
  size?: number;
  className?: string;
}

const StepStatusIcon: React.FC<StepStatusIconProps> = ({
  status,
  size = 14,
  className = "",
}) => {
  const cls = `flex-none ${ICON_COLOR[status]} ${className}`;
  switch (status) {
    case "succeeded":
      return <CheckCircle2 size={size} className={cls} aria-label="succeeded" />;
    case "running":
      return (
        <Loader2 size={size} className={`${cls} animate-spin`} aria-label="running" />
      );
    case "failed":
      return <XCircle size={size} className={cls} aria-label="failed" />;
    case "skipped":
      return <CircleSlash size={size} className={cls} aria-label="skipped" />;
    default:
      return <Circle size={size} className={cls} aria-label="pending" />;
  }
};

export default StepStatusIcon;
